(function () {
  var B = 'oddit-section-shop-merch';

  function initSection(section) {
    var track = section.querySelector('.' + B + '__track');
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    var dots = section.querySelector('.' + B + '__dots');
    if (!track || !prev || !next || !dots) return;

    var template = dots.querySelector('[data-carousel-dot]');
    if (!template) return;

    var step = 0;
    var maxScroll = 0;
    var autoplayTimer = null;
    var autoplayEnabled = section.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = (parseInt(section.getAttribute('data-autoplay-speed'), 10) || 5) * 1000;

    function measure() {
      var cards = track.querySelectorAll('.' + B + '__card');
      step = cards.length > 1
        ? cards[1].offsetLeft - cards[0].offsetLeft
        : track.clientWidth;
      maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

      var pages = step > 0 ? Math.ceil(maxScroll / step) + 1 : 1;
      while (dots.children.length > pages) dots.lastElementChild.remove();
      while (dots.children.length < pages) {
        dots.appendChild(template.cloneNode(true));
      }
      Array.prototype.forEach.call(dots.children, function (dot, i) {
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      });
    }

    function sync() {
      var x = track.scrollLeft;
      var last = dots.children.length - 1;
      var index = step > 0 ? Math.min(last, Math.round(x / step)) : 0;

      Array.prototype.forEach.call(dots.children, function (dot, i) {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      prev.disabled = x <= 1;
      next.disabled = x >= maxScroll - 1;
    }

    function advance() {
      if (track.scrollLeft >= maxScroll - 1) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: step, behavior: 'smooth' });
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled || autoplayTimer) return;
      autoplayTimer = setInterval(advance, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    prev.addEventListener('click', function () {
      stopAutoplay();
      track.scrollBy({ left: -step, behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      stopAutoplay();
      track.scrollBy({ left: step, behavior: 'smooth' });
    });

    dots.addEventListener('click', function (event) {
      var dot = event.target.closest('[data-carousel-dot]');
      if (!dot) return;
      stopAutoplay();
      var index = Array.prototype.indexOf.call(dots.children, dot);
      track.scrollTo({
        left: Math.min(index * step, maxScroll),
        behavior: 'smooth',
      });
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', startAutoplay);

    var frame = 0;
    track.addEventListener('scroll', function () {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        sync();
      });
    }, { passive: true });

    var ro = null;
    if (typeof ResizeObserver === 'function') {
      ro = new ResizeObserver(function () {
        measure();
        sync();
      });
      ro.observe(track);
    } else {
      window.addEventListener('resize', function () {
        measure();
        sync();
      });
    }

    measure();
    sync();
    startAutoplay();

    section._shopMerchCleanup = function () {
      stopAutoplay();
      if (ro) ro.disconnect();
    };
  }

  document.querySelectorAll('.' + B).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.' + B);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('.' + B);
    if (section && section._shopMerchCleanup) section._shopMerchCleanup();
  });
})();
